import React from 'react';
import { IProps } from './type';

const AccessTimeFilledIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke={strokeColor || '#090A0F'} strokeOpacity="0.87" strokeLinecap="round" />
      <path
        d="M12 7V10.283C12 11.3668 12 11.9087 12.2507 12.361C12.5014 12.8134 12.961 13.1006 13.88 13.675L16 15"
        stroke={strokeColor || fillColor || '#090A0F'}
        strokeOpacity="0.87"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AccessTimeFilledIcon;
